import React from "react";
import ScheduleGarrisonUtils from "../utils/schedulegarrison-utils.jsx";

const AddressContent = ({ address, isUpdate = false }) => {
    if (!address) return null;

    const { current, previous } = isUpdate ? ScheduleGarrisonUtils.splitDiff(address) : { current: address, previous: {} };

    return (
        <>
                <ScheduleGarrisonUtils.Row
                    isUpdate={isUpdate}
                    label="Local pré-cadastrado"
                    value={!isUpdate ? current.place : undefined}
                    newValue={ScheduleGarrisonUtils.getNew(current.place) ?? current.place}
                    oldValue={ScheduleGarrisonUtils.getOld(current.place) ?? previous.place}
                />

                <ScheduleGarrisonUtils.Row
                    isUpdate={isUpdate}
                    label="Tipo do local"
                    value={!isUpdate ? current.placeType : undefined}
                    newValue={ScheduleGarrisonUtils.getNew(current.placeType) ?? current.placeType}
                    oldValue={ScheduleGarrisonUtils.getOld(current.placeType) ?? previous.placeType}
                />

                <ScheduleGarrisonUtils.Row
                    isUpdate={isUpdate}
                    label="Logradouro"
                    value={!isUpdate ? current.street : undefined}
                    newValue={ScheduleGarrisonUtils.getNew(current.street) ?? current.street}
                    oldValue={ScheduleGarrisonUtils.getOld(current.street) ?? previous.street}
                />

                <ScheduleGarrisonUtils.Row
                    isUpdate={isUpdate}
                    label="Número"
                    value={!isUpdate ? current.number : undefined}
                    newValue={ScheduleGarrisonUtils.getNew(current.number) ?? current.number}
                    oldValue={ScheduleGarrisonUtils.getOld(current.number) ?? previous.number}
                />

                <ScheduleGarrisonUtils.Row
                    isUpdate={isUpdate}
                    label="Bairro"
                    value={!isUpdate ? current.neighborhood : undefined}
                    newValue={ScheduleGarrisonUtils.getNew(current.neighborhood) ?? current.neighborhood}
                    oldValue={ScheduleGarrisonUtils.getOld(current.neighborhood) ?? previous.neighborhood}
                />

                <ScheduleGarrisonUtils.Row
                    isUpdate={isUpdate}
                    label="Cruzamento"
                    value={!isUpdate ? current.crossroad : undefined}
                    newValue={ScheduleGarrisonUtils.getNew(current.crossroad) ?? current.crossroad}
                    oldValue={ScheduleGarrisonUtils.getOld(current.crossroad) ?? previous.crossroad}
                />

                <ScheduleGarrisonUtils.Row
                    isUpdate={isUpdate}
                    label="Ponto de referência"
                    value={!isUpdate ? current.referencePoint : undefined}
                    newValue={ScheduleGarrisonUtils.getNew(current.referencePoint) ?? current.referencePoint}
                    oldValue={ScheduleGarrisonUtils.getOld(current.referencePoint) ?? previous.referencePoint}
                />

                <ScheduleGarrisonUtils.Row
                    isUpdate={isUpdate}
                    label="Município"
                    value={!isUpdate ? current.city : undefined}
                    newValue={ScheduleGarrisonUtils.getNew(current.city) ?? current.city}
                    oldValue={ScheduleGarrisonUtils.getOld(current.city) ?? previous.city}
                />

                <ScheduleGarrisonUtils.Row
                    isUpdate={isUpdate}
                    label="Estado"
                    value={!isUpdate ? current.district : undefined}
                    newValue={ScheduleGarrisonUtils.getNew(current.district) ?? current.district}
                    oldValue={ScheduleGarrisonUtils.getOld(current.district) ?? previous.district}
                />

                <ScheduleGarrisonUtils.Row
                    isUpdate={isUpdate}
                    label="Latitude"
                    value={!isUpdate ? current.latitude : undefined}
                    newValue={ScheduleGarrisonUtils.getNew(current.latitude) ?? current.latitude}
                    oldValue={ScheduleGarrisonUtils.getOld(current.latitude) ?? previous.latitude}
                />

                <ScheduleGarrisonUtils.Row
                    isUpdate={isUpdate}
                    label="Longitude"
                    value={!isUpdate ? current.longitude : undefined}
                    newValue={ScheduleGarrisonUtils.getNew(current.longitude) ?? current.longitude}
                    oldValue={ScheduleGarrisonUtils.getOld(current.longitude) ?? previous.longitude}
                />

                <ScheduleGarrisonUtils.Row
                    isUpdate={isUpdate}
                    label="Setor"
                    value={!isUpdate ? ScheduleGarrisonUtils.formatArray(current.sectors) : undefined}
                    newValue={ScheduleGarrisonUtils.formatArray(ScheduleGarrisonUtils.getNew(current.sectors) ?? current.sectors)}
                    oldValue={ScheduleGarrisonUtils.formatArray(ScheduleGarrisonUtils.getOld(current.sectors) ?? previous.sectors)}
                />
        </>
    );
};

export default AddressContent;